module.exports = __webpack_public_path__ + "assets/img/icon2.331f10c7.png";